import type { SVGProps } from 'react';
const SvgNavVehiclesFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    height={24}
    fill="none"
    width={24}
    {...props}
  >
    <path
      d="M6 19v.5q0 .625-.437 1.063A1.45 1.45 0 0 1 4.5 21q-.625 0-1.062-.437A1.45 1.45 0 0 1 3 19.5v-7.15q0-.175.025-.35t.075-.325L4.975 6.35q.2-.6.725-.975T6.875 5h10.25q.65 0 1.175.375t.725.975l1.875 5.325q.05.15.075.325t.025.35v7.15q0 .625-.437 1.063A1.45 1.45 0 0 1 19.5 21q-.625 0-1.062-.437A1.45 1.45 0 0 1 18 19.5V19zm-.2-9h12.4l-1.05-3H6.85zm1.7 6q.624 0 1.063-.437Q9 15.125 9 14.5t-.437-1.062A1.45 1.45 0 0 0 7.5 13q-.625 0-1.062.438A1.45 1.45 0 0 0 6 14.5q0 .624.438 1.063Q6.874 16 7.5 16m9 0q.625 0 1.063-.437Q18 15.125 18 14.5t-.437-1.062A1.45 1.45 0 0 0 16.5 13q-.625 0-1.062.438A1.45 1.45 0 0 0 15 14.5q0 .624.438 1.063.437.437 1.062.437"
      fill="currentColor"
    />
  </svg>
);
export default SvgNavVehiclesFilled;
